export default __webpack_public_path__ + "resources/icons/n412-a162.png";